// extracted by mini-css-extract-plugin
export default {"auth-wrapper":"AuthModule_auth-wrapper__NprHb","hidden":"AuthModule_hidden__poANr"};